"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fdsChartsI18nSetup = void 0;
const i18n_1 = require("@tcc/i18n");
const en_json_1 = __importDefault(require("./en.json"));
let installed = false;
const fdsChartsI18nSetup = () => __awaiter(void 0, void 0, void 0, function* () {
    if (installed)
        return;
    yield (0, i18n_1.setup)({
        project: 'tcc-fds-charts',
        englishFile: en_json_1.default,
    });
    installed = true;
});
exports.fdsChartsI18nSetup = fdsChartsI18nSetup;
